import styled from "styled-components";
import media from "constants/media";

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const Info = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
`;

export const ButtonContainer = styled.div`
    margin-left: auto;

    a {
        margin-right: 20px;
    }
`;

export const Totals = styled.div`
    width: 100%;

    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;

    ${media.mdUp`
        font-size: 16px;
        line-height: 25px;
        width: auto;
    `}
`;

export const Quantity = styled.div`
    font-weight: 500;
`;

export const Price = styled.div`
    color: var(--color-peach);
    font-weight: 500;

    span {
        margin-right: 5px;
    }
`;
